
import { supabase } from "@/integrations/supabase/client";

export const getCheckoutUrl = async (userId: string): Promise<string> => {
  try {
    console.log('[Stripe Utils] Creating checkout session for user:', {
      userId,
      timestamp: new Date().toISOString()
    });

    const { data, error } = await supabase.functions.invoke('create-checkout-session', {
      body: { 
        user_id: userId
      },
    });

    console.log('[Stripe Utils] Supabase function response:', {
      hasData: !!data,
      hasError: !!error,
      errorMessage: error?.message,
      data,
      timestamp: new Date().toISOString()
    });

    if (error) {
      console.error('[Stripe Utils] Supabase function error:', {
        error: error?.message,
        userId,
        timestamp: new Date().toISOString()
      });
      throw new Error(`Failed to create checkout session: ${error.message}`);
    }

    if (!data?.url) {
      console.error('[Stripe Utils] No checkout URL received:', {
        data,
        userId,
        timestamp: new Date().toISOString()
      });
      throw new Error('No checkout URL received from Stripe');
    }

    console.log('[Stripe Utils] Checkout URL created successfully:', {
      userId,
      hasUrl: !!data.url,
      timestamp: new Date().toISOString()
    });

    return data.url;
  } catch (error) {
    console.error('[Stripe Utils] Error creating checkout URL:', {
      error: error instanceof Error ? error.message : 'Unknown error',
      userId,
      stack: error instanceof Error ? error.stack : undefined,
      timestamp: new Date().toISOString()
    });
    throw error;
  }
};

